import { PropsWithChildren, useContext, useEffect, useState } from "react";
import { Spinner, ToolbarButton, ToolbarDivider, ToolbarGroup, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
    InfoRegular
} from "@fluentui/react-icons";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { useNavigate, useParams } from "react-router-dom";
import { usePPA } from "context/ppa-context";
import { IApplicationRole, IApplicationRoleMembership } from "@interfaces/settings/permissions.interfaces";
import { IApiError } from "@interfaces/common.interfaces";
import LoadingErrorBar from "components/common/loading-error-bar/loading-error-bar";
import { getError } from "lib/utils";
import LoadingSpinner from "components/common/loading-spinner/loading-spinner";
import DeleteDialog from "components/common/delete-dialog/delete-dialog";
import ApplicationRolesTiles from "../application-roles-tiles/application-roles-tiles";
import { IApplicationRoleMembershipSectionProps } from "./application-role-membership-section.props";
import ApplicationRoleMembershipList from "../application-role-membership-list/application-role-membership-list";
import AppApplicationRoleMembershipDialog from "../add-application-role-membership-dialog/add-application-role-membership-dialog";

const layoutStyles = makeStyles({
    mainWrapper: {
        //...shorthands.borderWidth('1px', '0'),
    }
});


export default function ApplicationRoleMembershipSection(props: IApplicationRoleMembershipSectionProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();
    const { getApiClient } = usePPA();
    const navigate = useNavigate();
    const params = useParams();
    const [loading, setLoading] = useState<boolean>(false);
    const [apiError, setApiError] = useState<IApiError | null>(null);
    const [applicationRoleMembership, setApplicationRoleMembership] = useState<Array<IApplicationRoleMembership>>([]);
    const [addDialogProps, setAddDialogProps] = useState<{ apiUrl: string }>({ apiUrl: '' });
    const [addDialogIsOpen, setAddDialogIsOpen] = useState<boolean>(false);
    const [deleteDialogProps, setDeleteDialogProps] = useState<{ apiUrl: string, message: string }>({ apiUrl: '', message: '' });
    const [deleteDialogIsOpen, setDeleteDialogIsOpen] = useState<boolean>(false);

    const getApplicationRoleMembership = async (): Promise<Array<IApplicationRoleMembership>> => {
        try {
            const response = await getApiClient().get<Array<IApplicationRoleMembership>>(`/api/settings/permissions/application-roles/${params.id}/membership`);
            return response.data;
        }
        catch (ex: unknown) {
            throw ex;
        }
    }

    const loadApplicationRoleMembership = (showLoading: boolean) => {
        setLoading(showLoading);
        getApplicationRoleMembership().then(
            (membership: Array<IApplicationRoleMembership>) => {
                setApplicationRoleMembership(membership);
                setLoading(false);
            },
            (error: any) => {
                setApiError(getError(error));
                setLoading(false);
            });
    }

    useEffect(() => {
        loadApplicationRoleMembership(true);
    }, []);

    const onAddApplicationRoleMembership = () => {

        setAddDialogProps({
            apiUrl: `/api/settings/permissions/application-roles/${params.id}/membership`
        });
        setAddDialogIsOpen(true);
    }
    const onAddApplicationRoleMembershipSuccess = () => {
        setAddDialogIsOpen(false);
        loadApplicationRoleMembership(false);
    }

    const onDeleteApplicationRoleMembership = (items: Array<IApplicationRoleMembership>) => {
        const ids: string = items.map((item) => { return item.id }).join(',');

        setDeleteDialogProps({
            apiUrl: `/api/settings/permissions/application-roles/${params.id}/membership?ids=${ids}`,
            message: t("ppaApplicationRoleMembershipDeleteMessage", { count: items.length })
        });
        setDeleteDialogIsOpen(true);
    }
    const onDeleteApplicationRoleMembershipSuccess = () => {
        setDeleteDialogIsOpen(false);
        loadApplicationRoleMembership(false);
    }

    return (
        <>
            <ApplicationRoleMembershipList
                loading={loading}
                apiError={apiError}
                applicationRoleMembership={applicationRoleMembership}
                onAddApplicationRoleMembershipClick={onAddApplicationRoleMembership}
                onDeleteApplicationRoleMembershipClick={onDeleteApplicationRoleMembership} />
            <DeleteDialog
                isOpen={deleteDialogIsOpen}
                isOpenCallback={setDeleteDialogIsOpen}
                onSuccess={onDeleteApplicationRoleMembershipSuccess}
                title={t("ppaApplicationRoleMembershipDeleteTitle")}
                {...deleteDialogProps} />
            <AppApplicationRoleMembershipDialog
                isOpen={addDialogIsOpen}
                isOpenCallback={setAddDialogIsOpen}
                onSuccess={onAddApplicationRoleMembershipSuccess}
                {...addDialogProps} />
        </>
    );
}